/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React from 'react';
import {useAuth} from "../data/userContext";
import {Navigate, useLocation} from "react-router-dom";
import {isAuthenticated} from "../data/roles";

function RequireAuth(props) {
    const auth = useAuth()
    const location = useLocation()
    const {check, children} = props;
    const from = location.state?.from?.pathname || "/";
    if(!isAuthenticated(auth.user))
        return <Navigate to="/login" state={{ from: location }} />
    if(check !== undefined && !check(auth.user)){
        return <Navigate replace to={from} state={{ from: location }} />
    }
    return ( <>
            {children}
        </>
    );
}

export default RequireAuth;